import React, { useState } from 'react';
import {
  Container,
  ContentWrapper,
  LeftColumn,
  RightColumn,
  Title,
  ContactInfo,
  ContactItem,
  IconImageWhatsApp,
  IconImageEmail,
  ContactText,
  Description,
  ContactForm,
  FormGroup,
  Label,
  Input,
  TextArea,
  CheckboxContainer,
  Checkbox,
  CheckboxLabel,
  SubmitButton
} from './styles';

import whatsappIcon from '../../../images/whatsappicon.png';
import emailIcon from '../../../images/emailicon.png';


const Section7 = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    agreeTerms: false
  });
  
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form data:', formData);
  };
  
  return (
    <Container>
      <ContentWrapper>
        <LeftColumn>
          <Title>Entre em contato</Title>
          
          <ContactInfo>
            <ContactItem>
                <IconImageWhatsApp src={whatsappIcon} alt="WhatsApp Icon" />
              <ContactText>11 98196-1451 - WhatsApp Suporte</ContactText>
            </ContactItem>
            
            <ContactItem>
            {"\u00A0"}<IconImageEmail src={emailIcon} alt="Email Icon" />{"\u00A0"}
              <ContactText>contato@inglesfluencia.com.br</ContactText>
            </ContactItem>
          </ContactInfo>
          
          <Description>
            Se você deseja conversar sobre projetos, colaborações ou tirar dúvidas, 
            fique à vontade para enviar uma mensagem.
          </Description>
        </LeftColumn>
        
        <RightColumn>
          <ContactForm onSubmit={handleSubmit}>
            <FormGroup>
              <Label htmlFor="name">Nome</Label>
              <Input 
                type="text" 
                id="name" 
                name="name" 
                placeholder="Seu Nome" 
                value={formData.name}
                onChange={handleChange}
                required
              />
            </FormGroup>
            
            <FormGroup>
              <Label htmlFor="email">Endereço de Email</Label>
              <Input 
                type="email" 
                id="email" 
                name="email" 
                placeholder="seuemail@email.com" 
                value={formData.email}
                onChange={handleChange}
                required
              />
            </FormGroup>
            
            <FormGroup>
              <Label htmlFor="message">Digite sua mensagem</Label>
              <TextArea 
                id="message" 
                name="message" 
                rows="6" 
                value={formData.message}
                onChange={handleChange}
                required
              />
            </FormGroup>
            
            <CheckboxContainer>
              <Checkbox 
                type="checkbox" 
                id="agreeTerms" 
                name="agreeTerms" 
                checked={formData.agreeTerms}
                onChange={handleChange}
                required
              />
              <CheckboxLabel htmlFor="agreeTerms">
                Concordo com os termos de uso e privacidade
              </CheckboxLabel>
            </CheckboxContainer>
            
            <SubmitButton type="submit">Enviar</SubmitButton>
          </ContactForm>
        </RightColumn>
      </ContentWrapper>
    </Container>
  );
};

export default Section7;
